import { inject, Injectable } from "@angular/core";

import { ChartOptionsService } from "@features/charts/services/chart-options.service";
import { ChartDataService } from "@features/charts/services/chart-data.service";
import { GlobalService } from "@shared/services";
import { ChartData, ChartOptions } from "chart.js";

@Injectable({
  providedIn: "root",
})
export class ChartPageService {
  globalService = inject(GlobalService);
  chartOptionsService = inject(ChartOptionsService);
  chartDataService = inject(ChartDataService);

  getChartConfig(
    routeParam: string,
    isPlanData: boolean
  ): { data: ChartData<"bar">; options: ChartOptions<"bar">; chartTitle: string } {
    return {
      data: this.chartDataService.getChartData(routeParam, isPlanData),
      options: this.chartOptionsService.getChartOptions(routeParam),
      chartTitle: this.getChartTitle(routeParam),
    };
  }

  private getChartTitle(routeParam: string): string {
    switch (routeParam) {
      case "imax":
        return "IMAX";
      case "proj":
        return "PROJ";
      case "vmax":
        return "VMAX";
      case "work":
        return "Work";
      case "pvds":
        return "PVDs";
      case "training":
        return "Training";
      case "sick":
        return "Sick";
      default:
        return "";
    }
  }
}
